module.exports = __webpack_public_path__ + "img/home.7f36034d.svg";